import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Row, Col } from "react-bootstrap";
import { Alaap_dev } from "urlconfig";
import { useTranslation } from "react-i18next";

const OliveLocationFilter2 = ({ onChange }) => {
  const [locationData, setLocationData] = useState([]);
  const [level2Value, setLevel2Value] = useState(null);
  const [level3Value, setLevel3Value] = useState(null);
  const [level4Value, setLevel4Value] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    fetch(`${Alaap_dev}/api/alaap-location-masters`)
      .then((res) => res.json())
      .then((data) => {
        const formatted = data?.data?.[0]?.data || [];
        setLocationData(formatted);
      })
      .catch((err) => console.error("Error fetching location data", err));
  }, []);


  const level2Options = locationData?.map((item) => ({
    label: item.level_2.label,
    value: item.level_2.value,
    level_3: item.level_2.level_3,
  }));

  const level3Options =
    level2Value?.level_3?.map((item) => ({
      label: item.label,
      value: item.value,
      level_4: item.level_4,
    })) || [];

  const level4Options =
    level3Value?.level_4?.map((item) => ({
      label: item.label,
      value: item.value,
    })) || [];


  const handleLevel2 = (val) => {
    if (!val) {
      setLevel2Value(null);
      setLevel3Value(null);
      setLevel4Value(null);

      onChange({
        level2: "",
        level3: "",
        level4: "",
      });
      return;
    }

    setLevel2Value(val);
    setLevel3Value(null);
    setLevel4Value(null);

    onChange({
      level2: val.label,
      level3: "",
      level4: "",
    });
  };

  // ✅ LEVEL 3 (Municipality)
  const handleLevel3 = (val) => {
    if (!val) {
      setLevel3Value(null);
      setLevel4Value(null);

      onChange({
        level2: level2Value?.label || "",
        level3: "",
        level4: "",
      });
      return;
    }

    setLevel3Value(val);
    setLevel4Value(null);

    onChange({
      level2: level2Value?.label || "",
      level3: val.label,
      level4: "",
    });
  };

  // ✅ LEVEL 4 (Parish)
  const handleLevel4 = (val) => {
    if (!val) {
      setLevel4Value(null);

      onChange({
        level2: level2Value?.label || "",
        level3: level3Value?.label || "",
        level4: "",
      });
      return;
    }

    setLevel4Value(val);

    onChange({
      level2: level2Value?.label || "",
      level3: level3Value?.label || "",
      level4: val.label,
    });
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      height: "40px",
      minHeight: "40px",
      fontSize: "13px",
    }),
    menu: (p) => ({ ...p, zIndex: 99999 }),
  };

  return (
    <Row>
      <Col sm={4} className="mb-2">
        <Select
          options={level2Options}
          value={level2Value}
          onChange={handleLevel2}
          placeholder={t("Select District")}
          styles={customStyles}
          isClearable
        />
      </Col>

      <Col sm={4} className="mb-2">
        <Select
          options={level3Options}
          value={level3Value}
          onChange={handleLevel3}
          placeholder={t("Select Municipality")}
          isDisabled={!level2Value}
          styles={customStyles}
          isClearable
        />
      </Col>

      <Col sm={4} className="mb-2">
        <Select
          options={level4Options}
          value={level4Value}
          onChange={handleLevel4}
          placeholder={t("Select Parish")}
          isDisabled={!level3Value}
          styles={customStyles}
          isClearable
        />
      </Col>
    </Row>
  );
};

export default OliveLocationFilter2;
